import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';
import { TeamScorecard } from "@shared/models/team-scorecard";

const analysesUrl = `${environment.apiBaseUrl}platform/agilespace/analyses`;
const agileSpaceUrl = `${environment.apiBaseUrl}platform/agilespace`;
const agileSpaceUrlV1 = `${environment.apiBaseUrl}platform/agilespace/v2/analyses`
const analysesUrl2 = `${environment.apiBaseUrl}platform/agilespace/analyses/v2`;
const v2analysesUrl = `${environment.apiBaseUrl}platform/agilespace/v2-analyses`;

const headers = new HttpHeaders({
  'x-no-notification': 'true'
});

@Injectable({
  providedIn: SharedModule
})
export class AgileSpaceService {

  constructor(private http: HttpClient) { }

  list(
    {
      sortKey,
      sortValue,
      filter,
      filterTeams,
      page,
      searchKey
    }: {
      sortKey?: string,
      sortValue?: string,
      filterTeams?: string,
      filter?: string,
      page?: string,
      searchKey?: string
    }): Observable<AgileSpace.AgileSpaceModel> {
    let params = new HttpParams();

    if (sortKey) {
      params = params.append('sortKey', sortKey);
    }

    if (sortValue) {
      params = params.append('sortValue', sortValue);
    }

    if (filter) {
      params = params.append('filter', filter);
    }

    if (filterTeams) {
      params = params.append('filterTeams', filterTeams);
    }

    if (page) {
      params = params.append('page', page);
    }

    if (searchKey) {
      params = params.append('searchKey', searchKey);
    }

    return this.http.get<AgileSpace.AgileSpaceModel>(`${agileSpaceUrlV1}`, { params });
  }

  teamList(
    {
      sortKey,
      sortValue,
      filter,
      filterTeams,
      page,
      searchKey
    }: {
      sortKey?: string,
      sortValue?: string,
      filterTeams?: string,
      filter?: string,
      page?: string,
      searchKey?: string,
    }): Observable<any> {
    let params = new HttpParams();

    if (sortKey) {
      params = params.append('sortKey', sortKey);
    }

    if (sortValue) {
      params = params.append('sortValue', sortValue);
    }

    if (filter) {
      params = params.append('filter', filter);
    }

    if (filterTeams) {
      params = params.append('filterTeams', filterTeams);
    }

    if (page) {
      params = params.append('page', page);
    }

    if (searchKey) {
      params = params.append('searchKey', searchKey);
    }

    return this.http.get<any>(`${analysesUrl}/teams`, { params });
  }

  states(analysisIds: any): Observable<any> {
    let params = new HttpParams();
    if (analysisIds) {
      params = params.append('analysisIds', analysisIds)
    }
    return this.http.get<any>(`${analysesUrl}/states`, { params });
  }

  get(id: string): Observable<AgileSpaceDetail.AgileSpaceDetailModel> {
    return this.http.get<AgileSpaceDetail.AgileSpaceDetailModel>(`${analysesUrl}/${id}`);
  }

  updateAnalysis(id: string, data: AgileSpaceDetail.AnalysisSettings): Observable<any> {
    return this.http.put<any>(`${analysesUrl}/${id}`, data);
  }

  getAnalysisSettings(id: string): Observable<AgileSpaceDetail.AnalysisSettings> {
    return this.http.get<AgileSpaceDetail.AnalysisSettings>(`${analysesUrl}/${id}/detail`);
  }

  create(analysis: any, scopeId: string): Observable<AgileSpace.AgileSpaceModel> {
    let params = new HttpParams();
    if (scopeId) {
      params = params.append('scope', scopeId);
    }
    return this.http.post<AgileSpace.AgileSpaceModel>(`${analysesUrl}`, analysis, { params });
  }

  createV2(analysis: any): Observable<any> {
    return this.http.post<any>(`${v2analysesUrl}`, analysis);
  }

  updateV2Analysis(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${v2analysesUrl}/${id}`, data);
  }



  initializeTabList(addonId: any, scopeId: any): Observable<TeamScorecard.InitializeStepModel[]> {
    let params = new HttpParams();
    if (scopeId) {
      params = params.append('scopeId', scopeId);
    }
    return this.http.get<TeamScorecard.InitializeStepModel[]>(`${agileSpaceUrl}/addons/${addonId}/initialize`, { params });
  }



  updateinitializeTabList(isUpdate?: any, analysisId?: any, addonId?: any,): Observable<TeamScorecard.InitializeStepModel[]> {
    let params = new HttpParams();
    if (analysisId) {
      params = params.append('analysisId', analysisId);
    }

    if (isUpdate) {
      params = params.append('isUpdate', isUpdate);
    }

    return this.http.get<TeamScorecard.InitializeStepModel[]>(`${agileSpaceUrl}/addons/${addonId}/initialize`, { params });
  }

  getFieldUrl(url,boardType:any): Observable<AgileSpace.Fields> {
    return this.http.get<AgileSpace.Fields>(`${environment.apiBaseUrl}` + url + '&boardType='+boardType);
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${analysesUrl}/${id}`);
  }

  cancel(id: string): Observable<any> {
    return this.http.post<any>(`${analysesUrl}/${id}/stop`, {}, { headers });
  }

  cancelRunning(id: string): Observable<any> {
    return this.http.post<any>(`${analysesUrl}/${id}/cancel`, {}, { headers });
  }

  sync(id: string): Observable<any> {
    return this.http.put<any>(`${analysesUrl}/${id}/reanalyse`, {}, { headers });
  }

  fields(id: string, scopeId?: string): Observable<any> {
    let params = new HttpParams();
    if (scopeId) {
      params = params.append('scope', scopeId);
    }
    return this.http.get<any>(`${agileSpaceUrl}/addons/${id}/analyzer-templates`, { params });
  }

  getAddons(): Observable<Gitwiser.AddonModel[]> {
    return this.http.get<Gitwiser.AddonModel[]>(`${agileSpaceUrl}/addons`);
  }

  getResult(analysisId?: string, type?: string, date?: any, issueFilter?: any, typeFilter?: any, sprintId?: string): Observable<any> {
    let params = new HttpParams();

    if (date && date.fromDate) {
      params = params.append('fromDate', date.fromDate);
      if (date.toDate !== undefined) {
        params = params.append('toDate', date.toDate);
      }

    }
    if (date && !date.fromDate) {
      params = params.append('fromDate', date);
    }

    if (sprintId !== undefined) {
      params = params.append('sprintId', sprintId);
    }

    return this.http.get<any>(`${analysesUrl}/${analysisId}/results?type=${type}`, { params });
  }

  saveSettings(data, analysisId: string): Observable<any> {

    return this.http.post<any>(`${analysesUrl}/${analysisId}/settings`, data);
  }

  issueColumnsState(analysisId?: string, type?: string, date?: any, page?: any, searchByValues?: any, sorting? : any ,pageSize?:number, issueSortResetPage?:boolean): Observable<any> {

    const body = {
      analysisId,
      type,
      page,
      searchByValues,
      sorting,
      pageSize,
      resetPage: issueSortResetPage,
      fromDate: '',
      toDate: '',
    };

    if (date && date?.fromDate) {
      body.fromDate = date?.fromDate;
      body.toDate = date?.toDate;
    }

    if (date && !date?.fromDate) {
      body.fromDate = date;
      body.toDate = null;
    }

    return this.http.post<any>(`${analysesUrl2}/${analysisId}/results`, body, {headers});
  }

  updateSettings(data, analysisId: string): Observable<any> {

    return this.http.put<any>(`${analysesUrl}/${analysisId}/settings`, data);
  }

  getSettings(analysisId: string): Observable<any> {

    return this.http.get<any>(`${analysesUrl}/${analysisId}/settings`);
  }

  getSprints(analysisId: string): Observable<any> {
    return this.http.get<any>(`${analysesUrl}/${analysisId}/sprints`)
  }

  getIssueTypes(analysisId): Observable<any> {
    return this.http.get<any>(`${analysesUrl}/${analysisId}/issueTypes`)
  }

  getSprintReportDetail(analysisId: string, sprintId: string): Observable<any> {
    return this.http.get<any>(`${analysesUrl}/${analysisId}/sprints/${sprintId}`)
  }

  createNote(data, analysisId: string, widgetType?: string, sprintKey?: any, issueKey?: any, note?: any): Observable<any> {
    let params = new HttpParams();

    if (widgetType) {
      params = params.append('widgetType', widgetType);
    }

    if (sprintKey) {
      params = params.append('sprintKey', sprintKey);
    }

    if (issueKey) {
      params = params.append('issueKey', issueKey);
    }

    if (note) {
      params = params.append('note', note);
    }
    return this.http.post<any>(`${analysesUrl}/${analysisId}/issue-note`, data, { params });
  }

  reset(id: string): Observable<any> {
    return this.http.delete<any>(`${analysesUrl}/${id}/reset`, { headers });
  }

  getAnalysisAgileSpaceAnalysis(): Observable<Base.KeyLabelModel[]>{
    return this.http.get<Base.KeyLabelModel[]>(`${analysesUrl}/lite`);
  }

  getWorkItemTypes(addonName: string): Observable<any> {
    const params = new HttpParams()
      .append('addonName', addonName);

    return this.http.get<any>(`${agileSpaceUrl}/work-item-types`, { params });
  }
}
